/* eslint-disable jsx-a11y/anchor-is-valid */
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { buscarUnidad, listarTecnologiasTratamiento } from "../api/General";
import { useCatalog } from "../context/Catalog";
import { crearPlantaTratamiento } from "../utils/data";
import { isInvalid } from "../utils/forms";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import ArrayField from "./controls/ArrayField";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import { PlantaTratamientoForm } from "./PlantaTratamientoForm";
import { PlantaTratamientoList } from "./PlantaTratamientoList";
import AmmountField from "./controls/AmmountField";

export default function TratamientoEfluentesForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const tecnologiasCatalog = useCatalog(
    ["tecnologiasTratamiento", "LIQUIDO"],
    () => listarTecnologiasTratamiento({ tipo: "LIQUIDO" }),
  );
  const unidadPorcentajeCatalog = useCatalog(
    ["unidad", "PORCENTAJE"],
    () => buscarUnidad("PORCENTAJE"),
  );
  const loading =
    tecnologiasCatalog.loading || unidadPorcentajeCatalog.loading;
  const showTratamientoIndividual =
    tramiteForm.values?.actividadPrincipal?.esComplejoHabitacional ||
    tramiteForm.values?.actividadSecundaria?.esComplejoHabitacional;
  const handlePlantasTratamientoChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleTratamientoIndividualChange = (event) => {
    tramiteForm.handleChange(event);
  };
  return (
    <Loader loading={loading}>
      <Grid>
        {showTratamientoIndividual && (
          <Row>
            <Col>
              <AmmountField
                id="tratamientoIndividual"
                name="tratamientoIndividual"
                label={t("tramite.tratamientoIndividual")}
                value={tramiteForm.values.tratamientoIndividual}
                onChange={handleTratamientoIndividualChange}
                unit={unidadPorcentajeCatalog.data}
                isInvalid={isInvalid("tratamientoIndividual", tramiteForm)}
                error={t(tramiteForm.errors.tratamientoIndividual)}
                disabled={!isEditable(tramite)}
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <ArrayField
              id="plantasTratamiento"
              name="plantasTratamiento"
              label={t("tramite.plantasTratamiento")}
              value={tramiteForm.values.plantasTratamiento}
              onChange={handlePlantasTratamientoChange}
              createItem={crearPlantaTratamiento}
              isInvalid={isInvalid("plantasTratamiento", tramiteForm)}
              error={
                (tramiteForm.errors.plantasTratamiento instanceof Array &&
                  t("errors.tramite.plantasTratamiento.many")) ||
                t(tramiteForm.errors.plantasTratamiento)
              }
              disabled={!isEditable(tramite)}
            >
              {({
                value: plantasTratamiento,
                append,
                remove,
                replace,
                select,
                selectedIndex,
                selectedItem,
                disabled,
              }) => (
                <Grid>
                  <Row>
                    <Col>
                      <PlantaTratamientoForm
                        value={selectedItem}
                        page={selectedIndex}
                        pages={plantasTratamiento.length}
                        select={select}
                        append={append}
                        replace={replace}
                        remove={remove}
                        tecnologias={tecnologiasCatalog.data}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <PlantaTratamientoList
                        value={plantasTratamiento}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
